'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00247 from "./presto.-Agent-View$$anon$7.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dOpened$0024 from "./presto.-Agent-View$-Opened$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$6() {
  this.aA1 = null;
  this.azT = null;
  this.azU = false;
  this.aA2 = null;
  this.aA3 = false;
  this.aA6 = null;
  this.azZ = null;
  this.aA0 = false;
  this.azV = null;
  this.azW = false;
  this.azX = null;
  this.azY = false;
  this.aA4 = false;
  this.aA5 = false;
  this.aA1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aA6 = "Opened";
}
export { $c_Lpresto_AgentView$$anon$6 as $c_Lpresto_AgentView$$anon$6 };
$p = $c_Lpresto_AgentView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$6;
/** @constructor */
function $h_Lpresto_AgentView$$anon$6() {
}
export { $h_Lpresto_AgentView$$anon$6 as $h_Lpresto_AgentView$$anon$6 };
$h_Lpresto_AgentView$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aA1;
});
$p.L = (function() {
  if ((!this.azU)) {
    this.azT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.azU = true;
  }
  return this.azT;
});
$p.O = (function() {
  if ((!this.aA3)) {
    this.aA2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aA3 = true;
  }
  return this.aA2;
});
$p.E = (function() {
  return this.aA6;
});
$p.t = (function() {
  if ((!this.aA0)) {
    this.azZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.aA0 = true;
  }
  return this.azZ;
});
$p.M = (function() {
  if ((!this.azW)) {
    this.azV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.azW = true;
  }
  return this.azV;
});
$p.Q = (function() {
  if ((!this.azY)) {
    this.azX = new $j_presto$002e$002dAgent$002dView$0024$0024anon$00247.$c_Lpresto_AgentView$$anon$7();
    this.azY = true;
  }
  return this.azX;
});
$p.w = (function() {
  if ((!this.aA5)) {
    this.aA4 = false;
    this.aA5 = true;
  }
  return this.aA4;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee57) => ((p) => \u03b4scrutinee57))($j_presto$002e$002dAgent$002dView$0024$002dOpened$0024.$m_Lpresto_AgentView$Opened$())));
});
var $d_Lpresto_AgentView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$6, "presto.AgentView$$anon$6", ({
  Ea: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$6 as $d_Lpresto_AgentView$$anon$6 };
//# sourceMappingURL=presto.-Agent-View$$anon$6.js.map
